export const SituacaoPedido = {
  RASCUNHO: "Rascunho",
  BLOQUEADO: "Bloqueado",
  LIBERADO: "Liberado",
  FATURADO: "Faturado",
  CANCELADO: "Cancelado",
  PENDENTE: "Pendente",
  BLOQUEADO_COMERCIAL: "Bloqueado Comercial",
  BLOQUEADO_FINANCEIRO: "Bloqueado Financeiro",
  BLOQUEADO_TECNICO: "Bloqueado Tec."
};

export const SituacaoAnaliseTecnica = {
  PENDENTE: "Pendente",
  BLOQUEADA: "Bloqueada"
};

export function isBloqueadoTecnico(item) {
    if (!item) return false;
    const situacao = item.Situacao;
    const analise = item.SituacaoAnaliseTecnica || "";
    const financeiro = item.SituacaoFinanceira || "";
    const comercial = item.SituacaoComercial || "";

    return (
        (situacao === SituacaoPedido.BLOQUEADO && analise === SituacaoAnaliseTecnica.PENDENTE && financeiro === SituacaoPedido.LIBERADO && comercial === SituacaoPedido.LIBERADO) ||
        (situacao === SituacaoPedido.BLOQUEADO && analise === SituacaoAnaliseTecnica.BLOQUEADA && financeiro === SituacaoPedido.LIBERADO && comercial === SituacaoPedido.LIBERADO)
    );
}

export function getStyleStatusPedido(situacao) {
    if (situacao === SituacaoPedido.RASCUNHO) {
        return { background: "#efef97" };
    } else if (situacao === SituacaoPedido.BLOQUEADO) {
        return { background: "#81726A" };
    } else if (situacao === SituacaoPedido.LIBERADO) {
        return { background: "#ffffff", borderLeft: "3px solid #ddd" };
    } else if (situacao === SituacaoPedido.FATURADO) {
        return { background: "#9AC4F8" };
    } else if (situacao === SituacaoPedido.CANCELADO) {
        return { background: "#D64045" };
    } else if (situacao === SituacaoPedido.PENDENTE) {
        return { background: "#399E5A" };
    } else if (situacao === SituacaoPedido.BLOQUEADO_COMERCIAL) {
        return { background: "#A5A34E" };
    } else if (situacao === SituacaoPedido.BLOQUEADO_FINANCEIRO) {
        return { background: "#FF8000" };
    } else if (situacao === SituacaoPedido.BLOQUEADO_TECNICO) {
        return { background: "#DDA0DD" };
    }
    return { background: "#dddddd" };
}

export function getStyleBackgroundTicketPedido(item) {
    const situacao = item.Situacao;

    const baseStyle = {
        color: "white",
        display: "flex",
        flexDirection: "column",
        padding: "10px 8px",
        width: "180px", 
        minWidth: "180px",
        wordWrap: "break-word",
        "@media (max-width: 950px)": {
            width: "160px",
            minWidth: "160px",
        },
        "@media (max-width: 550px)": {
            width: "140px",
            minWidth: "140px",
        },
    };

    if (isBloqueadoTecnico(item)) {
        return { 
            ...baseStyle, 
            background: "#DDA0DD"
        };
    }

    if (situacao === SituacaoPedido.RASCUNHO) {
        return { ...baseStyle, background: "#efef97", color: "black" };
    } else if (situacao === SituacaoPedido.BLOQUEADO) {
        return { ...baseStyle, background: "#81726A" };
    } else if (situacao === SituacaoPedido.LIBERADO) {
        return { ...baseStyle, background: "#ffffff", color: "black", border: "1px solid #ddd" };
    } else if (situacao === SituacaoPedido.FATURADO) {
        return { ...baseStyle, background: "#9AC4F8", color: "black" };
    } else if (situacao === SituacaoPedido.CANCELADO) {
        return { ...baseStyle, background: "#D64045" };
    } else if (situacao === SituacaoPedido.PENDENTE) {
        return { ...baseStyle, background: "#399E5A" };
    } else if (situacao === SituacaoPedido.BLOQUEADO_COMERCIAL) {
        return { ...baseStyle, background: "#A5A34E" };
    } else if (situacao === SituacaoPedido.BLOQUEADO_FINANCEIRO) {
        return { ...baseStyle, background: "#FF8000" };
    } 
    return null;
}

export function getStyleFiltroPedido(situacao) {
    if (situacao === SituacaoPedido.RASCUNHO) {
        return { background: "#FFFFB4", color: "black" };
    } else if (situacao === SituacaoPedido.BLOQUEADO) {
        return { background: "#81726A", color: "white" };
    } else if (situacao === SituacaoPedido.LIBERADO) {
        return { background: "white", color: "black" };
    } else if (situacao === SituacaoPedido.FATURADO) {
        return { background: "#9AC4F8", color: "black" };
    } else if (situacao === SituacaoPedido.CANCELADO) {
        return { background: "#D64045", color: "white" };
    } else if (situacao === SituacaoPedido.PENDENTE) {
        return { background: "#399E5A", color: "white" };
    } else if (situacao === SituacaoPedido.BLOQUEADO_COMERCIAL) {
        return { background: "#A5A34E", color: "white" };
    } else if (situacao === SituacaoPedido.BLOQUEADO_FINANCEIRO) {
        return { background: "#FF8000", color: "white" };
    } else if (situacao === SituacaoPedido.BLOQUEADO_TECNICO) {
        return { background: "#DDA0DD", color: "black" };
    }
    return null;
}
